import { render, staticRenderFns } from "./CandidatesList.vue?vue&type=template&id=602a4db7&"
import script from "./CandidatesList.vue?vue&type=script&lang=js&"
export * from "./CandidatesList.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports